/**
 * @copyright chuzhixin 1204505056@qq.com
 * @description 路由守卫，目前两种模式：all模式与intelligence模式
 */
import router from "@/router";
import store from "@/store";
import getPageTitle from "@/utils/pageTitle";
import {
  authentication,
  loginInterception,
  recordRoute,
  routesWhiteList,
} from "./settings";

import { permission as permissionJson } from './permission.json'

router.beforeEach(async (to, from, next) => {
  let hasToken = store.getters["user/accessToken"];
  const now = (new Date()).getTime()
  const last = store.getters["user/refresh"];

  // 权限是否过时，拉去权限时，设置拉去权限时间为最后时间，
  // 比较当前与上次时间戳，如超出 600 秒，则为 true
  let hasRefresh = (now - last < 600000) ? false : true
  // 若未拉取过权限，hasRefresh 必为 true，进不到白名单处理
  // 若无 Token 则设置为 false
  if (last === 0 && !hasToken) hasRefresh = false;

  if (!loginInterception) hasToken = true;

  if (hasToken || hasRefresh) {
    if (to.path === "/login") {
      next();
    } else {
      await store.dispatch("user/getUserInfo");
      const hasPermissions = store.getters["user/permissions"] && store.getters["user/permissions"].length > 0;

      if (hasPermissions && !hasRefresh) {
        next();
      } else {
        try {
          let permissions;
          if (!loginInterception) {
            permissionJson?.list?.forEach((permission) => {
              const { detail } = permission
              permissions.push(...detail)
            })
            await store.dispatch("user/setPermissions", permissions);
          } else {
            permissions = await store.dispatch("user/getUserInfo");
            if (permissions === null) {
              next(`/login?redirect=${to.path}`);
            }
          }

          let accessRoutes = [];
          if (authentication === "intelligence") {
            accessRoutes = await store.dispatch(
              "routes/setRoutes",
              permissions
            );
          } else if (authentication === "all") {
            accessRoutes = await store.dispatch("routes/setAllRoutes");
          }
          await store.dispatch("user/setRefresh", now);
          router.addRoutes(accessRoutes);
          if (to.path === "/") {
            next("/login");
          } else {
            next({ ...to, replace: true });
          }
        } catch {
          await store.dispatch("user/resetAccessToken");
        }
      }
    }
  } else {
    if (routesWhiteList.indexOf(to.path) !== -1) {
      console.log('白名单')
      next();
    } else {
      console.log('非白名单?')
      if (recordRoute) {
        next(`/login?redirect=${to.path}`);
      } else {
        next("/login");
      }
    }
  }
  document.title = getPageTitle(to.meta.title);
});
